import React, { useEffect, useState } from 'react';
import api from '../api';

const ids = ['accounts-offer', 'accounts-privacy-agreement', 'privacy-policy'];
export default function RegistrationAgreements({ onChange, disabled = false }) {
    const [documents, setDocuments] = useState(null);
    const [failed, setFailed] = useState(false);
    const [attempt, setAttempt] = useState(0);
    const [terms, setTerms] = useState(false);
    const [personalData, setPersonalData] = useState(false);
    useEffect(() => {
        let active = true;
        setDocuments(null); setFailed(false); setTerms(false); setPersonalData(false);
        api.get('/api/auth/agreements').then(({ data }) => {
            const ordered = ids.map(id => data.find(document => document.id === id));
            if (ordered.some(document => !document?.url || !document?.accept_title || !document.version)) throw new Error('Missing agreement');
            if (active) setDocuments(ordered);
        }).catch(() => { if (active) setFailed(true); });
        return () => { active = false; };
    }, [attempt]);
    useEffect(() => {
        onChange(documents && terms && personalData ? {
            terms, personalData, versions: Object.fromEntries(documents.map(document => [document.id, document.version])),
        } : null);
    }, [documents, terms, personalData, onChange]);
    if (failed) return <div className="auth-error" role="alert">Не удалось загрузить документы. <button type="button" onClick={() => setAttempt(value => value + 1)}>Повторить</button></div>;
    if (!documents) return <p className="auth-description" role="status">Загрузка документов…</p>;
    const link = (index, text = documents[index].accept_title) => <a href={documents[index].url} target="_blank" rel="noopener noreferrer">{text}</a>;
    return <div className="auth-agreements">
        <label><input type="checkbox" required disabled={disabled} checked={terms} onChange={event => setTerms(event.target.checked)} /><span>Я согласен с условиями {link(0)}</span></label>
        <label><input type="checkbox" required disabled={disabled} checked={personalData} onChange={event => setPersonalData(event.target.checked)} /><span>Я даю {link(1, 'согласие')} на обработку персональных данных на условиях {link(2, 'Политики конфиденциальности')}</span></label>
    </div>;
}
